import Splide from "@splidejs/splide";

jQuery(function ($) {
	const base = "gc-cwv";

	if (!$(`.${base}__slider`).length) {
		return;
	}

	const slider = new Splide(`.${base}__slider`, {
		type: "loop",
		focus: "center",
		perPage: 1,
		arrows: false,
		pagination: true
	}).mount();

	$(`.${base}__slider-button--next`).click(function () {
		slider.go("+");
	});

	$(`.${base}__slider-button--prev`).click(function () {
		slider.go("-");
	});
});
